"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsFormSelectInput = void 0;
const DOM_1 = require("../../../../../public/js/utils/DOM");
const StringValidator_1 = require("../../../../../public/js/utils/Validator/StringValidator");
const SelectInputCreateTypeEnum_1 = require("./definitions/SelectInputCreateTypeEnum");
const Modal_1 = require("../../../../../public/js/utils/Modal");
const StringValidatorValidationType_1 = require("../../../../../public/js/definitions/utils/validator/stringValidator/StringValidatorValidationType");
const Price_1 = require("../../../../../public/js/utils/Price");
const TomSelect = require('tom-select');
var ControlsFormSelectInput;
(function (ControlsFormSelectInput) {
    class Config {
        static inputContainerClass = "SelectInput";
        static inputClass = "SelectInput-input";
        static searchInputContainerClassName = "dropdown-input-wrap";
        static searchInputElementClassName = "dropdown-input";
        static translationElementId = "jsTranslations";
        static customDataDataName = "customData";
        static createEnabledDataName = "allowCreate";
        static createEnabledTypeDataName = "allowCreateType";
        static customSearchTextDataName = "searchText";
        static customNoResultsTextDataName = "noResultsText";
        static customAddTextDataName = "addText";
        static changeModeDataName = "changeMode";
        static disableSearchOptionDataName = "disableSearch";
        static stringLabelDataName = "label";
        static inputControlElementClassName = "ts-control";
        static inputControlItemElementClassName = "item";
        static inputControlItemPriceLabelElementClassName = "priceLabel";
        static selectInputSelectedQuery = "option";
    }
    ControlsFormSelectInput.Config = Config;
    class Control {
        static initialize(container) {
            const inputs = DOM_1.DOM.Parser.getHtmlElements(Config.inputContainerClass, container, true);
            for (let i = 0; i < inputs.length; i++) {
                this.initializeElement(inputs[i]);
            }
        }
        static updateActiveOption(startIndex, options, eventKey, instance) {
            for (let i = startIndex; i < options.length; i++) {
                const optionValue = DOM_1.DOM.Parser.getDataByNameFromElementOrNull('value', options[i]);
                const optionValueFirstChar = optionValue === null ? null : optionValue.charAt(0);
                if (eventKey === optionValueFirstChar && !options[i].classList.contains('active')) {
                    instance.setActiveOption(options[i]);
                    return true;
                }
            }
            return false;
        }
        static initializeElement(element) {
            const input = DOM_1.DOM.Parser.getHtmlElementByClass(Config.inputClass, element);
            const translations = DOM_1.DOM.Parser.getHtmlElement(Config.translationElementId);
            const customNoResultsText = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.customNoResultsTextDataName, input);
            const customAddText = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.customAddTextDataName, input);
            const disableSearch = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.disableSearchOptionDataName, input) === 'yes';
            const stringLabel = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.stringLabelDataName, input);
            const changeMode = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.changeModeDataName, input) === 'yes';
            const isMultiSelectInput = input.classList.contains('MultiSelectInput');
            let options = {
                controlInput: null,
                render: {
                    no_results: function () {
                        return `
                            <div class="no-results">
                                ${customNoResultsText ?? DOM_1.DOM.Parser.getDataByNameFromElement('trsSelectNoResults', translations)}
                            </div>`;
                    },
                    option_create: function (data, escape) {
                        return `
                            <div class="create">
                                ${customAddText ?? DOM_1.DOM.Parser.getDataByNameFromElement('trsSelectAdd', translations)} 
                                <strong>${escape(data.input)}</strong>&hellip;
                            </div>`;
                    },
                },
                plugins: isMultiSelectInput ? {
                    'dropdown_input': true,
                    'checkbox_options': {
                        'checkedClassNames': ['ts-checked'],
                        'uncheckedClassNames': ['ts-unchecked'],
                    }
                } : {
                    'dropdown_input': true,
                },
                onDropdownOpen: (dropdown) => {
                    if (Modal_1.Modal.Helpers.getShownModal() !== null) {
                        dropdown.scrollIntoView({ block: "end", behavior: "instant" });
                    }
                },
                onInitialize: () => {
                    if (!isMultiSelectInput) {
                        setTimeout(() => {
                            Control.extPriceSelected(element, input, changeMode);
                        }, 500);
                    }
                }
            };
            options = this.extCustomData(options, input, changeMode);
            options = this.extCreate(options, input);
            const instance = new TomSelect(input, options);
            if (disableSearch) {
                DOM_1.DOM.Parser.getHtmlElementByClass(Config.searchInputContainerClassName, element).style.display = 'none';
                element.addEventListener('keyup', (event) => {
                    if (event.key.length !== 1) {
                        return;
                    }
                    const options = DOM_1.DOM.Parser.getHtmlElements('option', element);
                    const activeOptionIndex = instance.activeOption === null ? 0 : parseInt(instance.activeOption.id.split('-').slice(-1));
                    let foundInNextOptions = this.updateActiveOption(activeOptionIndex, options, event.key, instance);
                    if (!foundInNextOptions) {
                        this.updateActiveOption(0, options, event.key, instance);
                    }
                });
            }
            else {
                const searchIcon = document.createElement("img");
                searchIcon.src = '/resources/images/2023/search.svg';
                DOM_1.DOM.Parser.getHtmlElementByClass(Config.searchInputContainerClassName, element).prepend(searchIcon);
                const customSearchText = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.customSearchTextDataName, input);
                DOM_1.DOM.Parser.getHtmlElementByClass(Config.searchInputElementClassName, element).placeholder
                    = customSearchText ?? DOM_1.DOM.Parser.getDataByNameFromElement('trsSelectSearch', translations);
            }
            if (stringLabel) {
                DOM_1.DOM.Parser.getHtmlElementByQuery('label', DOM_1.DOM.Parser.getParentElement(DOM_1.DOM.Parser.getParentElement(input))).classList.add('active');
            }
        }
        static extPriceSelected(element, input, changeMode) {
            input.addEventListener('change', () => {
                this.extPriceSelected(element, input, changeMode);
            });
            const foundOption = this.findOptionInCustomData(input.value, input);
            if (!foundOption || !foundOption.price) {
                return;
            }
            const controlElement = DOM_1.DOM.Parser.getHtmlElementByClass(Config.inputControlElementClassName, element);
            const itemElement = DOM_1.DOM.Parser.getHtmlElementByClass(Config.inputControlItemElementClassName, controlElement);
            const priceLabel = controlElement.getElementsByClassName(Config.inputControlItemPriceLabelElementClassName);
            let priceLabelItem = priceLabel.length === 0 ? null : priceLabel[0];
            if (!priceLabelItem) {
                priceLabelItem = document.createElement("div");
                priceLabelItem.classList.add('priceLabel');
                itemElement.append(priceLabelItem);
            }
            const priceString = (new Price_1.Price.Initializer()).getPriceAmountStringFromPriceObject(foundOption.price, false, changeMode);
            priceLabelItem.innerHTML = priceString.length === 0 ? "&nbsp" : priceString;
        }
        static extCreate(options, input) {
            const createEnabled = DOM_1.DOM.Parser.getDataByNameFromElement(Config.createEnabledDataName, input) === 'yes';
            options.create = createEnabled;
            if (!createEnabled) {
                return options;
            }
            const createType = DOM_1.DOM.Parser.getDataByNameFromElement(Config.createEnabledTypeDataName, input);
            if (createType === SelectInputCreateTypeEnum_1.SelectInputCreateTypeEnum.EMAIL) {
                options.create = function (input) {
                    if (StringValidator_1.StringValidator.validateString(input, { meta: null, name: StringValidatorValidationType_1.StringValidatorValidationType.EMAIL })) {
                        return { value: input, text: input };
                    }
                    return false;
                };
                options.createFilter = function (input) {
                    return StringValidator_1.StringValidator.validateString(input, { meta: null, name: StringValidatorValidationType_1.StringValidatorValidationType.EMAIL });
                };
            }
            return options;
        }
        static extCustomData(options, input, changeMode) {
            const customData = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.customDataDataName, input);
            if (customData === null) {
                return options;
            }
            options.render.option = function (data, escape) {
                const foundOption = Control.findOptionInCustomData(data.value.toString(), input);
                const descriptionText = foundOption
                    ? foundOption.price
                        ? (new Price_1.Price.Initializer()).getPriceAmountStringFromPriceObject(foundOption.price, false, changeMode)
                        : foundOption.desc
                    : null;
                if (!descriptionText) {
                    return `<div data-value="${escape(data.value)}" role="option">${escape(data.text)}</div>`;
                }
                return `
                        <div data-value="${escape(data.value)}" role="option">
                            <div class="option-text">
                                <div class="option-text-title">${escape(data.text)}</div>
                                <div class="option-text-description">${escape(descriptionText)}</div>
                            </div>
                        </div>
                    `;
            };
            return options;
        }
        static findOptionInCustomData(identify, input) {
            const customData = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.customDataDataName, input);
            if (!customData) {
                return null;
            }
            const customDataDecoded = JSON.parse(customData);
            return customDataDecoded.find((item) => {
                return item.value.toString() === identify;
            }) ?? null;
        }
        static getSelectInputPriceList(input) {
            const prices = [];
            const selectElement = DOM_1.DOM.Parser.getHtmlElementByClass(Config.inputClass, input);
            const helperData = JSON.parse(DOM_1.DOM.Parser.getDataByNameFromElement(Config.customDataDataName, selectElement));
            const options = DOM_1.DOM.Parser.getHtmlElementsByQuery(Config.selectInputSelectedQuery, selectElement);
            for (let j = 0; j < options.length; j++) {
                const option = options[j];
                if (!option.selected) {
                    continue;
                }
                const price = this.getPriceFromSelectInputHelperData(option.value, helperData);
                if (price) {
                    prices.push(price);
                }
            }
            return prices;
        }
        static getPriceFromSelectInputHelperData(value, data) {
            for (const dataItem of data) {
                if (dataItem.value.toString() === value && dataItem.price) {
                    return dataItem.price;
                }
            }
            return null;
        }
    }
    ControlsFormSelectInput.Control = Control;
})(ControlsFormSelectInput || (exports.ControlsFormSelectInput = ControlsFormSelectInput = {}));
